import reducer from './terms-and-conditions-reducer';

export default reducer;
export { initialState } from './terms-and-conditions-reducer';

export * from './terms-and-conditions-actions';
